// extracted by mini-css-extract-plugin
export default {"filter":"styles_filter__OAZZi","sidebar":"styles_sidebar__Cjp84"};